import type { NameSearchResult } from './types';

const MOCK_SITTERS: NameSearchResult[] = [
  {
    personOpk: 'provider',
    personName: 'Provider Provider',
    shortName: 'Provider',
    avatarUrl: null,
    ratingsAverage: '5.0',
    reviewsCount: 47,
    tagline: 'I will take great care of your pet!',
    isStarSitter: true,
    profileUrl: '/members/provider/',
  },
  {
    personOpk: 'megan-c',
    personName: 'Megan Carter',
    shortName: 'Megan',
    avatarUrl: null,
    ratingsAverage: '4.9',
    reviewsCount: 31,
    tagline: 'Your pup will feel right at home with me and my golden retriever.',
    isStarSitter: true,
    profileUrl: '/members/megan-c/',
  },
  {
    personOpk: 'sherri-s',
    personName: 'Sherri Smith',
    shortName: 'Sherri',
    avatarUrl: null,
    ratingsAverage: '4.8',
    reviewsCount: 22,
    tagline: 'Professional dog walker and certified pet first aid provider.',
    isStarSitter: false,
    profileUrl: '/members/sherri-s/',
  },
  {
    personOpk: 'jkl012',
    personName: 'Emily Parker',
    shortName: 'Emily',
    avatarUrl: null,
    ratingsAverage: '5.0',
    reviewsCount: 63,
    tagline: 'Retired vet tech who adores all animals, big and small.',
    isStarSitter: true,
    profileUrl: '/members/jkl012/',
  },
  {
    personOpk: 'mno345',
    personName: 'James Wilson',
    shortName: 'James',
    avatarUrl: null,
    ratingsAverage: '4.7',
    reviewsCount: 15,
    tagline: 'Active lifestyle, daily hikes, and plenty of belly rubs.',
    isStarSitter: false,
    profileUrl: '/members/mno345/',
  },
  {
    personOpk: 'pqr678',
    personName: 'Lisa Nguyen',
    shortName: 'Lisa',
    avatarUrl: null,
    ratingsAverage: '4.9',
    reviewsCount: 38,
    tagline: 'Cat specialist! I know exactly how to keep your kitty happy.',
    isStarSitter: true,
    profileUrl: '/members/pqr678/',
  },
  {
    personOpk: 'stu901',
    personName: 'David Kim',
    shortName: 'David',
    avatarUrl: null,
    ratingsAverage: '4.6',
    reviewsCount: 9,
    tagline: 'New to Rover but lifelong dog dad to three rescue pups.',
    isStarSitter: false,
    profileUrl: '/members/stu901/',
  },
  {
    personOpk: 'vwx234',
    personName: 'Rachel Martinez',
    shortName: 'Rachel',
    avatarUrl: null,
    ratingsAverage: '4.8',
    reviewsCount: 27,
    tagline: 'Flexible schedule and a home full of love for your furry family.',
    isStarSitter: false,
    profileUrl: '/members/vwx234/',
  },
  {
    personOpk: 'a1b2c3',
    personName: 'Amanda Brooks',
    shortName: 'Amanda',
    avatarUrl: null,
    ratingsAverage: '4.7',
    reviewsCount: 19,
    tagline: 'Fenced yard, quiet neighborhood, and two friendly cats at home.',
    isStarSitter: false,
    profileUrl: '/members/a1b2c3/',
  },
  {
    personOpk: 'd4e5f6',
    personName: 'Sarah Williams',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.5',
    reviewsCount: 12,
    tagline: 'Part-time pet sitter, full-time animal enthusiast.',
    isStarSitter: false,
    profileUrl: '/members/d4e5f6/',
  },
  {
    personOpk: 'g7h8i9',
    personName: 'Nathan Rivera',
    shortName: 'Nathan',
    avatarUrl: null,
    ratingsAverage: '5.0',
    reviewsCount: 55,
    tagline: 'Former shelter volunteer. Every dog deserves a great day!',
    isStarSitter: true,
    profileUrl: '/members/g7h8i9/',
  },
  {
    personOpk: 'j0k1l2',
    personName: 'Maria Santos',
    shortName: 'Maria',
    avatarUrl: null,
    ratingsAverage: '4.9',
    reviewsCount: 41,
    tagline: 'Bilingual sitter with 10+ years of pet care experience.',
    isStarSitter: true,
    profileUrl: '/members/j0k1l2/',
  },
  {
    personOpk: 'm3n4o5',
    personName: 'Alex Thompson',
    shortName: 'Alex',
    avatarUrl: null,
    ratingsAverage: '4.6',
    reviewsCount: 8,
    tagline: 'Work from home so your pup always has company.',
    isStarSitter: false,
    profileUrl: '/members/m3n4o5/',
  },
  {
    personOpk: 'p6q7r8',
    personName: 'Jessica Chang',
    shortName: 'Jessica',
    avatarUrl: null,
    ratingsAverage: '4.8',
    reviewsCount: 33,
    tagline: 'Treats, toys, and tons of cuddles guaranteed.',
    isStarSitter: true,
    profileUrl: '/members/p6q7r8/',
  },
  {
    personOpk: 's9t0u1',
    personName: 'Brandon Lee',
    shortName: 'Brandon',
    avatarUrl: null,
    ratingsAverage: '4.7',
    reviewsCount: 17,
    tagline: 'Marathon runner who loves long walks with furry friends.',
    isStarSitter: false,
    profileUrl: '/members/s9t0u1/',
  },
  {
    personOpk: 'v2w3x4',
    personName: 'Samantha Davis',
    shortName: 'Samantha',
    avatarUrl: null,
    ratingsAverage: '5.0',
    reviewsCount: 72,
    tagline: "Your pet will be so spoiled they won't want to leave!",
    isStarSitter: true,
    profileUrl: '/members/v2w3x4/',
  },
  {
    personOpk: 'y5z6a7',
    personName: 'Daniel Hernandez',
    shortName: 'Daniel',
    avatarUrl: null,
    ratingsAverage: '4.4',
    reviewsCount: 6,
    tagline: 'Calm, patient, and great with anxious pets.',
    isStarSitter: false,
    profileUrl: '/members/y5z6a7/',
  },
  {
    personOpk: 'b8c9d0',
    personName: 'Laura Mitchell',
    shortName: 'Laura',
    avatarUrl: null,
    ratingsAverage: '4.9',
    reviewsCount: 44,
    tagline: 'Certified dog trainer offering boarding and enrichment activities.',
    isStarSitter: true,
    profileUrl: '/members/b8c9d0/',
  },
  {
    personOpk: 'e1f2g3',
    personName: 'Sarah Patel',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.8',
    reviewsCount: 29,
    tagline: 'Spacious apartment, close to the park, and allergy-friendly.',
    isStarSitter: false,
    profileUrl: '/members/e1f2g3/',
  },
  {
    personOpk: 'h4i5j6',
    personName: 'Chris Anderson',
    shortName: 'Chris',
    avatarUrl: null,
    ratingsAverage: '4.7',
    reviewsCount: 21,
    tagline: 'Night owl sitter — perfect for late drop-offs and early pickups.',
    isStarSitter: false,
    profileUrl: '/members/h4i5j6/',
  },
  {
    personOpk: 'k7l8m9',
    personName: 'Megan Taylor',
    shortName: 'Megan',
    avatarUrl: null,
    ratingsAverage: '5.0',
    reviewsCount: 58,
    tagline: 'Vet student who treats every pet like their own.',
    isStarSitter: true,
    profileUrl: '/members/k7l8m9/',
  },
  {
    personOpk: 'n0o1p2',
    personName: 'Ryan Garcia',
    shortName: 'Ryan',
    avatarUrl: null,
    ratingsAverage: '4.5',
    reviewsCount: 14,
    tagline: 'Big house, big heart, and a big love for dogs of all sizes.',
    isStarSitter: false,
    profileUrl: '/members/n0o1p2/',
  },
  {
    personOpk: 'q3r4s5',
    personName: 'Olivia Baker',
    shortName: 'Olivia',
    avatarUrl: null,
    ratingsAverage: '4.8',
    reviewsCount: 36,
    tagline: 'Homemade dog treats and daily photo updates included!',
    isStarSitter: true,
    profileUrl: '/members/q3r4s5/',
  },
  {
    personOpk: 't6u7v8',
    personName: 'Jason Clark',
    shortName: 'Jason',
    avatarUrl: null,
    ratingsAverage: '4.6',
    reviewsCount: 11,
    tagline: 'Former firefighter with a gentle touch for nervous pets.',
    isStarSitter: false,
    profileUrl: '/members/t6u7v8/',
  },
  {
    personOpk: 'w9x0y1',
    personName: 'Hannah Wright',
    shortName: 'Hannah',
    avatarUrl: null,
    ratingsAverage: '4.9',
    reviewsCount: 49,
    tagline: 'Cat whisperer and dog enthusiast — all pets welcome here.',
    isStarSitter: true,
    profileUrl: '/members/w9x0y1/',
  },
  {
    personOpk: 'z2a3b4',
    personName: 'Marcus Robinson',
    shortName: 'Marcus',
    avatarUrl: null,
    ratingsAverage: '4.3',
    reviewsCount: 4,
    tagline: 'New sitter eager to build a great reputation. Flexible hours!',
    isStarSitter: false,
    profileUrl: '/members/z2a3b4/',
  },
  {
    personOpk: 'c5d6e7',
    personName: 'Ashley Morgan',
    shortName: 'Ashley',
    avatarUrl: null,
    ratingsAverage: '4.7',
    reviewsCount: 25,
    tagline: 'Dog mom to a husky, so I know how to handle high-energy pups.',
    isStarSitter: false,
    profileUrl: '/members/c5d6e7/',
  },
  {
    personOpk: 'f8g9h0',
    personName: 'Sam Nakamura',
    shortName: 'Sam',
    avatarUrl: null,
    ratingsAverage: '4.8',
    reviewsCount: 30,
    tagline: 'Quiet, structured routine — ideal for senior dogs and puppies.',
    isStarSitter: true,
    profileUrl: '/members/f8g9h0/',
  },
  {
    personOpk: 'sarah01',
    personName: 'Sarah Adams',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.9',
    reviewsCount: 52,
    tagline: 'Lifelong dog lover with a quiet home and fenced yard.',
    isStarSitter: true,
    profileUrl: '/members/sarah01/',
  },
  {
    personOpk: 'sarah02',
    personName: 'Sarah Bennett',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.7',
    reviewsCount: 18,
    tagline: 'Work-from-home sitter, always around for company and care.',
    isStarSitter: false,
    profileUrl: '/members/sarah02/',
  },
  {
    personOpk: 'sarah03',
    personName: 'Sarah Carter',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '5.0',
    reviewsCount: 64,
    tagline: 'Experienced with puppies, seniors, and special-needs dogs.',
    isStarSitter: true,
    profileUrl: '/members/sarah03/',
  },
  {
    personOpk: 'sarah04',
    personName: 'Sarah Diaz',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.8',
    reviewsCount: 26,
    tagline: 'Cozy apartment near the park — walks included every day.',
    isStarSitter: false,
    profileUrl: '/members/sarah04/',
  },
  {
    personOpk: 'sarah05',
    personName: 'Sarah Evans',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.6',
    reviewsCount: 13,
    tagline: 'Gentle with anxious pups, firm with the rowdy ones.',
    isStarSitter: false,
    profileUrl: '/members/sarah05/',
  },
  {
    personOpk: 'sarah06',
    personName: 'Sarah Foster',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.9',
    reviewsCount: 39,
    tagline: 'Former vet tech with a soft spot for rescues.',
    isStarSitter: true,
    profileUrl: '/members/sarah06/',
  },
  {
    personOpk: 'sarah07',
    personName: 'Sarah Gupta',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.7',
    reviewsCount: 21,
    tagline: 'Daily photo updates and lots of backyard playtime.',
    isStarSitter: false,
    profileUrl: '/members/sarah07/',
  },
  {
    personOpk: 'sarah08',
    personName: 'Sarah Harris',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '5.0',
    reviewsCount: 71,
    tagline: 'Five-star sitter, flexible schedule, calm household.',
    isStarSitter: true,
    profileUrl: '/members/sarah08/',
  },
  {
    personOpk: 'sarah09',
    personName: 'Sarah Iverson',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.5',
    reviewsCount: 9,
    tagline: 'New to the platform, but a lifelong dog parent.',
    isStarSitter: false,
    profileUrl: '/members/sarah09/',
  },
  {
    personOpk: 'sarah10',
    personName: 'Sarah Jackson',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.8',
    reviewsCount: 34,
    tagline: 'Hikes, beach trips, and homemade treats for your pup.',
    isStarSitter: true,
    profileUrl: '/members/sarah10/',
  },
  {
    personOpk: 'sarah11',
    personName: 'Sarah Kowalski',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.7',
    reviewsCount: 24,
    tagline: 'Multi-lingual sitter, patient with every personality.',
    isStarSitter: false,
    profileUrl: '/members/sarah11/',
  },
  {
    personOpk: 'sarah12',
    personName: 'Sarah Lopez',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.9',
    reviewsCount: 46,
    tagline: 'Spacious house, two dog-friendly cats, and no other pets visiting.',
    isStarSitter: true,
    profileUrl: '/members/sarah12/',
  },
  {
    personOpk: 'sarah13',
    personName: 'Sarah Moreno',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.6',
    reviewsCount: 16,
    tagline: 'Retired teacher who treats every dog like a student — lots of enrichment.',
    isStarSitter: false,
    profileUrl: '/members/sarah13/',
  },
  {
    personOpk: 'sarah14',
    personName: 'Sarah Novak',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.8',
    reviewsCount: 28,
    tagline: 'Three long walks a day, and a very soft couch for naps.',
    isStarSitter: false,
    profileUrl: '/members/sarah14/',
  },
  {
    personOpk: 'sarah15',
    personName: 'Sarah O’Brien',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '5.0',
    reviewsCount: 83,
    tagline: 'Over 100 stays completed. Your dog is in very good hands.',
    isStarSitter: true,
    profileUrl: '/members/sarah15/',
  },
  {
    personOpk: 'sarah16',
    personName: 'Sarah Park',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.7',
    reviewsCount: 20,
    tagline: 'Quiet home, no children, perfect for older or shy dogs.',
    isStarSitter: false,
    profileUrl: '/members/sarah16/',
  },
  {
    personOpk: 'sarah17',
    personName: 'Sarah Quinn',
    shortName: 'Sarah',
    avatarUrl: null,
    ratingsAverage: '4.9',
    reviewsCount: 37,
    tagline: 'Certified in pet CPR and first aid. Safety first, fun second.',
    isStarSitter: true,
    profileUrl: '/members/sarah17/',
  },
];

// Mock postal codes so dev can exercise refine-by-location against the mock.
// Two zips, both Seattle-area: 98104 (Downtown Seattle) and 98056 (Renton).
type MockPostal = '98104' | '98056';

const POSTAL_BY_OPK: Record<string, MockPostal> = {
  provider: '98104',
  'megan-c': '98104',
  'sherri-s': '98056',
};

function postalForOpk(opk: string): MockPostal {
  if (POSTAL_BY_OPK[opk]) return POSTAL_BY_OPK[opk];
  return opk.charCodeAt(0) % 2 === 0 ? '98104' : '98056';
}

function locationMatches(searchLocation: string | undefined, sitterPostal: MockPostal): boolean {
  if (!searchLocation) return true;
  const trimmed = searchLocation.trim().toLowerCase();
  if (!trimmed) return true;
  if (trimmed.includes('98104')) return sitterPostal === '98104';
  if (trimmed.includes('98056')) return sitterPostal === '98056';
  // Seattle covers both zips; Renton only covers 98056.
  if (trimmed.includes('seattle')) return true;
  if (trimmed.includes('renton')) return sitterPostal === '98056';
  // Anything else (e.g. "Boston, MA") returns empty — exercises the empty-refine state.
  return false;
}

// Slated for deletion when the real /api/current/search-by-name/ endpoint lands.
export function searchByName(query: string, location?: string): Promise<NameSearchResult[]> {
  return new Promise((resolve) => {
    setTimeout(() => {
      const normalizedQuery = query.toLowerCase().trim();
      if (!normalizedQuery) {
        resolve([]);
        return;
      }

      const results = MOCK_SITTERS.filter(
        (sitter) =>
          sitter.personName.toLowerCase().includes(normalizedQuery) &&
          locationMatches(location, postalForOpk(sitter.personOpk))
      );

      resolve(results);
    }, 500);
  });
}
